"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigratePlaceRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.MigratePlaceRequestStruct = (0, superstruct_1.type)({
    placeFrom: (0, superstruct_1.string)(),
    placeTo: (0, superstruct_1.string)(),
    organisationId: (0, superstruct_1.string)(),
    notifyUsers: (0, superstruct_1.boolean)(),
});
//# sourceMappingURL=MigratePlaceRequest.js.map